<div class="automation-page">

  <!-- ================= HEADER ================= -->
  <div class="automation-header">

    <div class="header-content">
      <div class="status-summary">

        <div class="summary-item active-summary">
          <span class="summary-dot"></span>
          <span>{{active}} Active</span>
        </div>

        <div class="summary-item paused-summary">
          <span class="summary-dot"></span>
          <span>{{paused}} Paused</span>
        </div>

        <div class="summary-item ended-summary">
          <span class="summary-dot"></span>
          <span>{{completed}} Completed</span>
        </div>

      </div>

    </div>

    <div class="automation-actions">

      <!-- Three Dot Menu Button -->
      <button mat-icon-button [matMenuTriggerFor]="automationMenu" matTooltip="More actions"
        class="automation-menu-btn">

        <mat-icon>more_vert</mat-icon>
      </button>

      <!-- Dropdown Menu -->
      <mat-menu #automationMenu="matMenu" class="automation-menu">

        <!-- New Automation -->
        <button mat-menu-item (click)="createAutomation()">
          <mat-icon>add</mat-icon>
          <span>New Automation</span>
        </button>

        <!-- Import Automation Templates -->
        <button mat-menu-item (click)="ImportTaskTemplate()">
          <mat-icon>import_export</mat-icon>
          <span>Import Automation Templates</span>
        </button>

        <!-- Save as Templates -->
        <button mat-menu-item (click)="SaveAsTemplate(saveAsTemplateDialog)">
          <mat-icon>save</mat-icon>
          <span>Save as Templates</span>
        </button>

      </mat-menu>

    </div>

    <!-- <div class="automation-actions">
  <button class="new-automation-btn" (click)="ImportTaskTemplate()">
    <mat-icon>import_export</mat-icon>
    <span>Import Automation Templates</span>
  </button>

  <button class="new-automation-btn" (click)="createAutomation()">
    <mat-icon>add</mat-icon>
    <span>New Automation</span>
  </button>
   </div> -->

  </div>


  <!-- ================= STATUS SUMMARY ================= -->


  <!-- ================= FILTER ROW ================= -->
  <!-- <div class="filter-row"> -->

  <!-- CATEGORY TABS -->
  <!-- <div class="category-tabs">

      <button
        class="category-tab"
        [class.active]="selectedCategory === 'All'"
        (click)="selectCategory('All')">
        All (8)
      </button>

      <button
        class="category-tab"
        [class.active]="selectedCategory === 'Tasks'"
        (click)="selectCategory('Tasks')">
        Tasks (3)
      </button>

      <button
        class="category-tab"
        [class.active]="selectedCategory === 'Reminders'"
        (click)="selectCategory('Reminders')">
        Reminders (2)
      </button>

      <button
        class="category-tab"
        [class.active]="selectedCategory === 'Docs'"
        (click)="selectCategory('Docs')">
        Docs &amp; Forms (3)
      </button>

      <button
        class="category-tab"
        [class.active]="selectedCategory === 'Other'"
        (click)="selectCategory('Other')">
        Other (0)
      </button>

    </div> -->


  <!-- SEARCH -->
  <!-- <div class="search-box">

      <mat-icon>search</mat-icon>

      <input
        type="text"
        placeholder="Search automations..."
        [(ngModel)]="searchText">

    </div> -->

  <!-- </div> -->


  <!-- ================= TABLE ================= -->
  <table class="automation-table">

    <colgroup>
      <col class="automation-col">
      <col class="action-col">
      <col class="frequency-col">
      <col class="trigger-col">
      <col class="assigned-col">
      <col class="attached-col">
      <col class="status-col">
      <col class="delete-col">
    </colgroup>

    <!-- TABLE HEADER -->
    <thead>
      <tr class="table-header">

        <th class="table-cell automation-col">
          AUTOMATION
        </th>

        <th class="table-cell action-col">
          ACTION
        </th>

        <th class="table-cell frequency-col">
          FREQUENCY
        </th>

        <th class="table-cell trigger-col">
          NEXT TRIGGER
        </th>

        <th class="table-cell assigned-col">
          ASSIGNED TO
        </th>

        <th class="table-cell attached-col">
          ATTACHED TO
        </th>

        <th class="table-cell status-col">
          STATUS
        </th>

        <!-- AFTER STATUS -->
        <th class="table-cell delete-col">
          ACTION
        </th>

      </tr>
    </thead>


    <!-- ================= ROWS ================= -->
    <tbody>
      <tr class="table-row" *ngFor="let task of taskList">

        <td class="table-cell automation-col" (click)="getTaskDetail(task)">
          <div class="automation-name">
            {{ task.taskTitle }}
          </div>

          <div class="automation-description">
            {{ task.description }}
          </div>
        </td>

        <td class="table-cell action-col" (click)="getTaskDetail(task)">

          <!-- Any -->
          <span class="action-badge any" *ngIf="task.action == 1">
            <span class="action-symbol">✦</span>
            Any
          </span>

          <!-- Form -->
          <span class="action-badge form" *ngIf="task.action == 2">
            <span class="action-symbol">▤</span>
            Form
          </span>

          <!-- Document -->
          <span class="action-badge document" *ngIf="task.action == 3">
            <span class="action-symbol">▣</span>
            Document
          </span>

          <!-- Video -->
          <span class="action-badge video" *ngIf="task.action == 4">
            <span class="action-symbol">▶</span>
            Video
          </span>

          <!-- URL -->
          <span class="action-badge url" *ngIf="task.action == 5">
            <span class="action-symbol">🔗</span>
            URL
          </span>

          <!-- Email -->
          <span class="action-badge email" *ngIf="task.action == 6">
            <span class="action-symbol">✉</span>
            Email
          </span>

        </td>

        <td class="table-cell frequency-col" (click)="getTaskDetail(task)">
          {{ getRepeatDays(task) || '-' }}
        </td>

        <td class="table-cell trigger-col" (click)="getTaskDetail(task)">
          {{ task?.nextTriggerDate ? (task.nextTriggerDate | date: 'MM/dd/yyyy') : '-' }}
        </td>

        <td class="table-cell assigned-col">
          <div class="userpicinfo">

            <ul class="assignList">

              <ng-container
                *ngFor="let item of getAssigne(task.taskAssignedEntity); let i = index; trackBy: trackByFn; ">
                <li *ngIf="i <= 3">
                  <ng-container *ngIf="item.image; else showName">
                    <div class="userImage" matTooltipClass="tooltip" matTooltip="{{item.name}}">
                      <img src="{{item.image}}" alt="{{item.name}}">
                    </div>
                  </ng-container>

                  <ng-template #showName>
                    <span class="shortName" matTooltipClass="tooltip" matTooltip="{{item.name}}">
                      {{ getShortName(item.name) }}
                    </span>
                  </ng-template>
                </li>
                <li *ngIf="i > 3 && i == 4">
                  <span class="shortName">
                    +{{4}}
                  </span>
                </li>
              </ng-container>

              <ng-container *ngIf="getAssigne(task.taskAssignedEntity).length == 0;">
                <li> - </li>
              </ng-container>

            </ul>


          </div>

          <!-- {{ task.assignedTo }} -->
        </td>

        <td class="table-cell attached-col">

          <span style="cursor: pointer;" *ngIf="task.entityTypeAttached==1" matTooltipClass="tooltip"
            matTooltip="Task location: {{CoreShowName}}">
            <mat-icon>app_registration</mat-icon>
          </span>
          <span style="cursor: pointer;" *ngIf="task.entityTypeAttached==2" matTooltipClass="tooltip"
            matTooltip="Task location: {{ContactShowName}}">
            <mat-icon>contact_mail</mat-icon>
          </span>
          <span style="cursor: pointer;" *ngIf="task.entityTypeAttached==3" matTooltipClass="tooltip"
            matTooltip="Task location: {{CompanyShowName}}">
            <mat-icon>business</mat-icon>
          </span>
          <span matTooltipClass="tooltip"
            matTooltip="{{getAttach(task.taskAttachedEntity)}}">{{getAttachShortName(task.taskAttachedEntity)}}</span>
          <!-- {{ task.attachedTo }} -->
        </td>

        <td class="table-cell status-col">

          <select class="status-select" [(ngModel)]="task.automationStatus"
            (ngModelChange)="changeAutomationStatus($event, task)">

            <option [value]="0">Draft</option>

            <option [value]="1">Active</option>

            <option [value]="2">Paused</option>

            <option [value]="3">Completed</option>

          </select>

        </td>

        <td class="table-cell delete-col">
          <button mat-icon-button class="delete-btn" matTooltip="Delete Task" matTooltipClass="tooltip"
            (click)="deleteTask(task)" type="button">
            <mat-icon>delete</mat-icon>
          </button>
        </td>

      </tr>
    </tbody>

  </table>

</div>

<ng-container *ngIf="showCreateTask">
  <mat-card class="createTask setMaxH" cdkDrag cdkDragBoundary=".right">
    <app-addAutomationTask (getCloseCreateTask)="getCloseCreateTask()" (getSaveTask)="getSaveTask()" [taskId]="taskId"
      [taskListID]="taskListID" [moduleName]="moduleNames" [name]="name" [email]="email" [imageUrl]="imageUrl"
      [transactionID]="transactionID" [typeId]="typeIdForTask" [typeIdDrp]="TypeIdDrp">
    </app-addAutomationTask>
  </mat-card>
</ng-container>


<app-task-details *ngIf="showTaskDetail" [ngClass]="{ open: showTaskDetail }"
  (closeTaskDetail)="closeTaskDetail($event)" (closeSaveTaskDetail)="closeSaveTaskDetail($event)"
  (showPI)="showPIntelligence($event)" [taskId]="taskId" [mainModulename]="mainModuleName"
  [SingleTaskArchived]="SingleTaskArchived" [showAddGroupButtonCore]="showAddGroupButtonCore">
</app-task-details>

<ng-template #saveAsTemplateDialog>

  <form [formGroup]="addTemplateForm" class="save-template-form">

    <!-- =========================
         Dialog Header
         ========================= -->
    <h2 mat-dialog-title class="save-template-title">

      <div class="title-left">

        <span class="groupIcon">
          <mat-icon>create_new_folder</mat-icon>
        </span>

        <span class="title-text">
          Save/Update Template
        </span>

      </div>

      <button type="button" mat-icon-button class="close-btn" matTooltip="Close" (click)="closeSaveAsTemplate()">

        <mat-icon>close</mat-icon>

      </button>

    </h2>


    <!-- =========================
         Dialog Content
         ========================= -->
    <mat-dialog-content class="save-template-content">

      <!-- Template Type -->
      <div class="template-type-section">

        <mat-radio-group color="primary" aria-label="Select template type" class="template-type-group">

          <!-- My Templates -->
          <mat-radio-button value="0" [checked]="categoryType == 0" (change)="OnCategoryChange(0)">

            My Templates

          </mat-radio-button>


          <!-- Organization Template -->
          <mat-radio-button *ngIf="isOrganizationAdmin" value="2" [checked]="categoryType == 2"
            (change)="OnCategoryChange(2)">

            Save as Organization Template

          </mat-radio-button>


          <!-- Global Template -->
          <mat-radio-button *ngIf="isSuperAdmin" value="1" [checked]="categoryType == 1" (change)="OnCategoryChange(1)">

            Save Global Template Only

          </mat-radio-button>

        </mat-radio-group>

      </div>


      <!-- =========================
           Tabs
           ========================= -->
      <mat-tab-group class="template-tabs" mat-stretch-tabs="false" mat-align-tabs="start"
        (selectedTabChange)="getTabDetails($event)">


        <!-- ==================================================
             NEW TEMPLATE
             ================================================== -->
        <mat-tab label="New">

          <div class="tabContainer">

            <!-- Category + Add -->
            <div class="category-row">

              <mat-form-field appearance="fill" class="category-field">

                <mat-label>
                  Select Category
                </mat-label>

                <mat-select formControlName="folderID">

                  <mat-option *ngFor="let stat of filteredTaskCategoryList" [value]="stat.taskTemplateCategoryID">

                    {{ stat.taskTemplateCategoryName }}

                  </mat-option>

                </mat-select>

              </mat-form-field>


              <!-- Add Category -->
              <button type="button" mat-icon-button color="primary" class="addBtn" matTooltip="Add Category"
                (click)="openDialogAddWithRef()">

                <mat-icon>
                  add
                </mat-icon>

              </button>

            </div>


            <!-- Template Name -->
            <mat-form-field appearance="fill" class="template-name-field">

              <mat-label>
                Template Name
              </mat-label>

              <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="Add template name" />

            </mat-form-field>

          </div>

        </mat-tab>


        <!-- ==================================================
             UPDATE EXISTING
             ================================================== -->
        <mat-tab label="Update Existing">

          <div class="tabContainer">

            <!-- Search + Category -->
            <div class="searchSelectCat">

              <!-- Category -->
              <div class="selectCat">

                <mat-form-field appearance="fill">

                  <mat-label>
                    Select Category
                  </mat-label>

                  <mat-select (selectionChange)="getSelectTaskCategory($event)">

                    <mat-option value="0">
                      All
                    </mat-option>

                    <mat-option *ngFor="let stat of filteredTaskCategoryList" [value]="stat.taskTemplateCategoryID">

                      {{ stat.taskTemplateCategoryName }}

                    </mat-option>

                  </mat-select>

                </mat-form-field>

              </div>


              <!-- Search -->
              <div class="search">

                <mat-form-field appearance="fill">

                  <mat-label>
                    Search
                  </mat-label>

                  <input matInput maxlength="20" placeholder="Search template"
                    (input)="searchTemplate($event.target.value)" />

                </mat-form-field>

              </div>

            </div>


            <!-- =========================
                 Template Table
                 ========================= -->
            <div class="tempalteList">

              <table cellspacing="0" cellpadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">

                <thead>

                  <tr>

                    <th>
                      Template Name
                    </th>

                    <th>
                      Category Name
                    </th>

                    <th class="actBtn">
                      Action
                    </th>

                  </tr>

                </thead>


                <tbody>

                  <tr *ngFor="let template of TaskTemplatesList" [ngClass]="{
                      'active':
                        template.taskTemplateID === taslTemplateID
                    }">

                    <!-- Template Name -->
                    <td class="formName">

                      <span [matTooltip]="template.taskTemplateName">

                        {{ template.taskTemplateName }}

                      </span>

                    </td>


                    <!-- Category -->
                    <td>

                      <span *ngIf="template.folderName">
                        {{ template.folderName }}
                      </span>

                      <span *ngIf="!template.folderName">
                        -
                      </span>

                    </td>


                    <!-- Action -->
                    <td class="actBtn">

                      <button type="button" mat-icon-button color="primary" matTooltip="Select"
                        matTooltipClass="tooltip" (click)="SelectTemplateForAddTaskList(template)">

                        <mat-icon>
                          post_add
                        </mat-icon>

                      </button>

                    </td>

                  </tr>

                </tbody>

              </table>


              <!-- No Records -->
              <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">

                <mat-icon>
                  folder_open
                </mat-icon>

                <span>
                  No Records Found
                </span>

              </div>

            </div>

          </div>

        </mat-tab>

      </mat-tab-group>

    </mat-dialog-content>


    <!-- =========================
         NEW TEMPLATE FOOTER
         ========================= -->
    <mat-dialog-actions *ngIf="showNew" class="template-actions" align="start">

      <button type="button" mat-button color="basic" (click)="closeSaveAsTemplate()">

        Cancel

      </button>


      <button type="button" mat-flat-button class="calltoaction" color="primary" [disabled]="
          addTemplateForm.invalid ||
          !addTemplateForm.dirty
        " (click)="AddTaskTemplate(addTemplateForm.value)">

        <span>
          Add
        </span>

        <mat-spinner *ngIf="spinner" diameter="18">
        </mat-spinner>

      </button>

    </mat-dialog-actions>


    <!-- =========================
         UPDATE TEMPLATE FOOTER
         ========================= -->
    <mat-dialog-actions *ngIf="showExisting" class="template-actions" align="start">

      <button type="button" mat-button color="basic" (click)="closeSaveAsTemplate()">

        Cancel

      </button>


      <button type="button" mat-flat-button class="calltoaction" color="primary"
        [disabled]="!updateTaskTemplateTasksButton" (click)="updateTaskTemplateTasks(addTemplateForm.value)">

        <span>
          Update
        </span>

        <mat-spinner *ngIf="spinner" diameter="18">
        </mat-spinner>

      </button>

    </mat-dialog-actions>

  </form>

</ng-template>